import { render, staticRenderFns } from "./profile1.vue?vue&type=template&id=d2c63090&"
import script from "./profile1.vue?vue&type=script&lang=js&"
export * from "./profile1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports